/**
 * Classe para manipulação de strings 
 * 
 * @author Wellington Pereira
 * @since 2014-03-11
 * @version 6.0.0
 * @license Comercial
 * @class
 */

 const Strings = {
  /**
   * Adiciona barras em caracteres especiais.
   * 
   * @returns {string}
   */
  addslashes: function () {
    return this
      .replace(/\\/g, '\\\\')
      .replace(/\u0008/g, '\\b')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\f/g, '\\f')
      .replace(/\r/g, '\\r')
      .replace(/'/g, '\\\'')
      .replace(/"/g, '\\"');
  },

  /**
   * Codifica a string de html para texto
   * 
   * @returns {string}
   */
  html_decode: function () {
    return this
      .toString()
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;');
  },

  /**
   * Codifica a string de texto para html
   * 
   * @returns {string}
   */
  html_encode: function () {
    return this
      .toString()
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"');
  },

  /**
   * Elimina todos os acentos da string
   * 
   * @returns {string}
   */
  normalize: function () {
    return this
      .replace(/[áàãâä]/gi, 'a')
      .replace(/[éèêë]/gi, 'e')
      .replace(/[íìîï]/gi, 'i')
      .replace(/[óòõôö]/gi, 'o')
      .replace(/[úùûü]/gi, 'u')
      .replace(/[ýÿ]/gi, 'y')
      .replace(/[ç]/gi, 'c')
      .replace(/[ñ]/gi, 'n');
      //       .normalize("NFD")                   // separa acentos
      // .replace(/[\u0300-\u036f]/g, "")    // remove marcas de acento
      // .toLowerCase()                      // tudo minúsculo
      // .trim()                             // tira espaços extras
      // .replace(/[^a-z0-9\s-]/g, "")       // remove caracteres que não são letras/números/espaço/hífen
      // .replace(/\s+/g, "-")               // troca espaços por "-"
      // .replace(/-+/g, "-");               // colapsa múltiplos "-"
  
  },

  /**
   * Cria nome de variável válida
   * 
   * @returns {string}
   */
  normalizePlus: function () {
    return this
      .normalize(str)
      .replace(/[\s]+/g, '-')
      .replace(/[^A-Za-z0-9_-]+/g, '')
      .toLowerCase();
  },

  /**
   * Repete várias vezes uma string.
   * 
   * @param {integer} repeat
   * @returns {string}
   */
  repeat: function (repeat) {
    let str = this;
    let newstr = '';
    for (let i = 0; i < repeat; i++) {
      newstr += str;
    }
    return newstr;
  },

  /**
   * Elimina caracteres especiais de uma lista
   * 
   * @param {array} list
   * @returns {string}
   */
  stripChars: function (list) {
    if (list === undefined) {
      list = ['&nbsp;', '&gt;', '&lt;'];
    }

    let newList = list.join('|');
    let reg = new RegExp(newList, 'g');
    return this.replace(reg, '');
  },

  /**
   * Retira barras em caracteres especiais.
   * 
   * @returns {string}
   */
  stripslashes: function () {
    return this
      .replace(/\\\\/g, '\\').
      replace(/\\b/g, '\u0008').
      replace(/\\t/g, '\t').
      replace(/\\n/g, '\n').
      replace(/\\f/g, '\f').
      replace(/\\r/g, '\r').
      replace(/\\\'/g, '\'').
      replace(/\\"/g, '"');
  },

  /**
   * Elimina todas as tags do texto
   * 
   * @returns {string}
   */
  stripTags: function () {
    const value = String(this);

    if (typeof document !== 'undefined') {
      const template = document.createElement('template');
      template.innerHTML = value;
      return template.content.textContent || '';
    }

    return value.replace(/<[^>]*>/g, '');
  },

  /**
   * Recupera parte de uma string
   * @param {integer} start 
   * @param {integer} length 
   * @returns string
   */
  substr: function(start, length) {
    if(length === undefined || typeof length !== 'number'){
      length = this.length;
      if(start < 0){
        start = length + start;
      }
    }
    
    const end = (length >= 0)?(start + length):(this.length + length);
    return this.substring(start, end);
  },

  /**
   * Converte em entidade html
   * 
   * @returns {string}
   */
  toHtmlEntities: function (str) {
    return this.toString().replace(/./gm, function (s) {
      return "&#" + s.charCodeAt(0) + ";";
    });
  },

  /**
   * Elimina os espaços excedentes no começo e no fim de uma string
   * 
   * @returns {string} 
   */
  trim: function () {
    return this
      .replace(/^[\s]+/, '')
      .replace(/[\s]+$/, '');
  }
};

const extendString = () => {
  for (let prop in Strings) {
    if (Strings.hasOwnProperty(prop)) {
      String.prototype[prop] = function (...args) {
        return Strings[prop].apply(this, args);
      };
    }
  }
}

export default extendString;
